import React, { useState, useEffect } from 'react';
import PropertyCard from './PropertyCardNew';
import PropertyDetailsList from "../../JsonData/property-details.json"
import { Button, Spin, Modal } from 'antd';
import { useParams, useHistory } from "react-router-dom";
import BuildingType from "../../JsonData/BuildingType.json"
import { deslugify } from '../../utils/slugify';



const SearchGridNeww = ({ setNewPropertyHeader, newPropertyHeader }) => {
    const { type, buildingType, constructionSlugs, locality, bedrooms } = useParams();
    const [filteredProperties, setFilteredProperties] = useState([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();



    let Buildingdata = BuildingType.BuildingType

    const typeMap = {
        buy: 'Buy',
        sell: 'Sell',
        rent: 'Rent/Lease'
    };

    const buildingTypeMap = {
        apartment: 'Apartment',
        townhouse: 'Townhouse',
        villas: 'Villas',
        penthouse: "Penthouse",
        'studio-apartment': 'Studio'
    };

    const constructionTypeMap = {
        ready: 'ready',
        offplan: 'offplan'
    };

    const bedroomsMap = {
        "1bedrooms": "1bedrooms",
        "2bedrooms": "2bedrooms",
        "3bedrooms": "3bedrooms",
        "4bedrooms": "4bedrooms"
    };



    const searchParams = new URLSearchParams(window.location.search);

    const [propertyFor, setPropertyFor] = useState(
        type ? typeMap[type] : searchParams.get('PropertyFor') || ''
    );

    const [selectBuildingType, setSelectedBuildingType] = useState(
        type ? buildingTypeMap[buildingType] : searchParams.get('PropertyType') || ''
    )

    const [selectedConstructionType, setSelectedConstructionType] = useState(
        type ? constructionTypeMap[constructionSlugs] : searchParams.get('ConstructionType') || ''
    );

    const [selectLocality, setSelectedLocality] = useState(
        locality ? deslugify(locality) : searchParams.get('Locality') || ''
    );

    // const [selectBHK, setSelectedBHK] = useState(
    //     bedrooms ? bedroomsMap[bedrooms.toLowerCase()] : searchParams.get('BedroomsType') || ''
    // );
    const [selectBHK, setSelectedBHK] = useState(
    bedrooms && typeof bedrooms === "string"
        ? bedroomsMap[bedrooms.toLowerCase()] || ''
        : searchParams.get('BedroomsType') || ''
);

    useEffect(() => {
        if (type === 'buy') {
            setPropertyFor('1');
        } else if (type === 'rent') {
            setPropertyFor('2');
        }
        else if (type === 'sell') {
            setPropertyFor('3');
        }
    }, [type]);


    useEffect(() => {

        setLoading(true)

        if (!PropertyDetailsList?.PropertyDetailsList) {
            console.error('Invalid property data structure');
            setFilteredProperties([]);
            setNewPropertyHeader([]);
            setLoading(false);
            return;
        }

        let filtered = [...PropertyDetailsList.PropertyDetailsList];

        // Filter by property type (buy/rent)
        if (type) {
            const typeMap = {
                buy: 'Buy',
                sell: 'Sell',
                rent: 'Rent/Lease'
            };
        //     filtered = filtered.filter(prop =>
        //         prop.property_type.toLowerCase().includes(typeMap[type].toLowerCase()))
        // }
        filtered = filtered.filter(prop =>
    prop.property_type && prop.property_type.toLowerCase().includes(typeMap[type].toLowerCase()));
        }

        // Filter by building type
        if (buildingType) {
            const buildingTypeMap = {
                apartment: 'Apartment',
                townhouse: 'Townhouse',
                villas: 'Villas',
                penthouse: "Penthouse",
                'studio-apartment': 'Studio Apartment'
            };
        //     filtered = filtered.filter(prop =>
        //         prop.building_type.toLowerCase().includes(buildingTypeMap[buildingType].toLowerCase()))
        // }
        filtered = filtered.filter(prop =>
    prop.building_type &&
    buildingTypeMap[buildingType] &&
    prop.building_type.toLowerCase().includes(
        buildingTypeMap[buildingType].toLowerCase()
    )
);
        }

        // Filter by construction type (ready/offplan)
        // if (constructionSlugs) {
        //     filtered = filtered.filter(prop =>
        //         prop.constructionType?.toLowerCase() === selectedConstructionType.toLowerCase())
        // }
        if (constructionSlugs && selectedConstructionType) {
    filtered = filtered.filter(
        prop =>
            prop.constructionType &&
            prop.constructionType.toLowerCase() === selectedConstructionType.toLowerCase()
    );
}


const isBedroomSlug =
  locality && /^\d+bedrooms$/.test(locality.toLowerCase());


        // Filter by locality
        // if (locality && locality.toLowerCase() !== "locality") {
        //     const localitySlug = locality.replace(/-/g, " ").toLowerCase();
        //     filtered = filtered.filter(
        //         (prop) => prop.locality.toLowerCase() === localitySlug

                // Normalize both the search term and property locality
                // const propLocality = prop.locality.toLowerCase().replace(/\s+/g, ' ').trim();
                // const searchLocality = localitySlug.replace(/\s+/g, ' ').trim();

                // // More flexible matching options:
                // return (
                //     propLocality === searchLocality || // Exact match
                //     propLocality.includes(searchLocality) || // Contains
                //     searchLocality.includes(propLocality) || // Reverse contains
                //     propLocality.replace(/\s/g, '') === searchLocality.replace(/\s/g, '') // No spaces match
                // );
        //     );
        // }
        if (
  locality &&
  locality.toLowerCase() !== "locality" &&
  !isBedroomSlug
) {
  const localitySlug = locality.replace(/-/g, " ").toLowerCase();
  filtered = filtered.filter(
    prop =>
      prop.locality &&
      prop.locality.toLowerCase() === localitySlug
  );
}


        // if (selectBHK) {
        //     filtered = filtered.filter(prop =>
        //         prop.bedrooms_type && prop.bedrooms_type.toLowerCase() === selectBHK.toLowerCase()
        //     );
        // }

        // Filter by bedrooms
        if (selectBHK) {
            filtered = filtered.filter(prop => {
                if (!prop.bedrooms_type) return false;

                // Ensure we handle both proper arrays and your current comma-separated format
                // const bedroomsList = prop.bedrooms_type
                //     .flatMap(item => item.split(",").map(b => b.trim().toLowerCase()));
    //             const bedroomsList = Array.isArray(prop.bedrooms_type)
    // ? prop.bedrooms_type.flatMap(item =>
    //     item.split(",").map(b => b.trim().toLowerCase())
    //   )
    // : prop.bedrooms_type
    //     ? prop.bedrooms_type.split(",").map(b => b.trim().toLowerCase())
    //     : [];
const bedroomsList = Array.isArray(prop.bedrooms_type)
  ? prop.bedrooms_type.flatMap(item =>
      item
        .split(",")
        .map(b => b.toLowerCase().replace(/\s/g, ''))
    )
  : prop.bedrooms_type
    ? prop.bedrooms_type
        .split(",")
        .map(b => b.toLowerCase().replace(/\s/g, ''))
    : [];


                // Match against the selected BHK
                // return bedroomsList.includes(selectBHK.toLowerCase());

                return bedroomsList.includes(
    selectBHK.toLowerCase().replace(/\s/g, '')
);

            });
        }


        console.log('Filtered properties:', {
            filters: { type, buildingType, constructionSlugs, locality },
            results: filtered
        });

        // if (!type && !buildingType && !constructionSlugs && !locality) {
        //     filtered = [...PropertyDetailsList.PropertyDetailsList];
        // }
        if (
    !type &&
    !buildingType &&
    !constructionSlugs &&
    !locality &&
    !selectBHK
) {
    filtered = [...PropertyDetailsList.PropertyDetailsList];
}


        setFilteredProperties(filtered);
        setNewPropertyHeader(filtered);
        setLoading(false)
    }, [type, buildingType, constructionSlugs, locality, selectBHK]);

    const handleFilterChange = (key, value) => {
        let updatedType = type;
        let updatedBuilding = buildingType;
        let updatedConstruction = constructionSlugs;
        let updatedLocality = locality;
        let updatedBhk = selectBHK;


        if (key === 'PropertyFor') {
            updatedType = value === '1' ? 'buy' : value === '2' ? 'rent' : 'sell';
            setPropertyFor(value);
        }

        if (key === 'PropertyType') {
            const buildingSlugMap = {
                Apartment: 'apartment',
                Townhouse: 'townhouse',
                Villas: 'villas',
                Penthouse: 'penthouse',
                "Studio-Apartment": 'studio-apartment',
            };
            updatedBuilding = buildingSlugMap[value] || '';
            setSelectedBuildingType(value);
        }

        if (key === 'ConstructionType') {
            updatedConstruction = value.toLowerCase();
            setSelectedConstructionType(value);
        }

        // Locality
        if (key === 'Locality') {
            updatedLocality = value.toLowerCase().replace(/\s+/g, '-'); // "Damac Hills2" → "damac-hills2"
            setSelectedLocality(value);
        }

        if (key === 'BedroomsType') {
            updatedBhk = value;
            setSelectedBHK(value);
            setQueryParams('BedroomsType', value); // update query param
        }

        // console.log(updatedBuilding, "clear.....buildingtype");

        let path = '/properties';
        if (updatedType) path += `/${updatedType}`;
        if (updatedBuilding) path += `/${updatedBuilding}`;
        if (updatedConstruction) path += `/${updatedConstruction}`;
        if (updatedLocality) path += `/${updatedLocality}`;
        if (updatedBhk) path += `/${updatedBhk}`;

        history.push(path);
    }

    const setQueryParams = (key, value) => {
        if (value) {
            searchParams.set(key, value);
        } else {
            searchParams.delete(key);
        }
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        window.history.replaceState(null, '', newUrl);
    };


    const handleResetFilter = () => {
        setPropertyFor('');
        setSelectedBuildingType('');
        setSelectedConstructionType('');
        setSelectedLocality('');
        setSelectedBHK('');

        const newUrl = `/properties`;
        history.push(newUrl);

        // Clear query params
        history.replace('/properties');
    };

    //   if (loading) {
        //     return <div>Loading properties...</div>;
        //   }
        
        const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < 768);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

    return (
        <div className="search-page-wrap pd-top-100 pd-bottom-70">
            <div className="search-container">
                <div className="container">
                    <div className="row">
                        {/* {type ? `${type.charAt(0).toUpperCase() + type.slice(1)}` : 'All'} Properties
                        {buildingType ? ` - ${buildingType.replace('-', ' ')}` : ''}
                        {constructionSlugs ? ` - ${constructionSlugs === 'offplan' ? 'Off Plan' : 'Ready'}` : ''}
                        {locality ? ` in ${locality.replace(/-/g, ' ')}` : ''} */}

                        {/* Filters */}
                        <div className="col-12 mb-4">
                            <div className="filter-bar d-flex flex-wrap align-items-center justify-content-between" style={{ gap: "15px" }}>
                                {/* Each filter dropdown */}
                                {/* Property For */}
                                <div style={isMobile ? { width: "340px" } : { width: "190px" }}>
                                    <label className="d-block" style={{ color: "#ffffff" }}>Property For</label>
                                    <select
                                        className="form-control"
                                        value={propertyFor}
                                        // onChange={(e) => {
                                        //     setQueryParams('PropertyFor', e.target.value);
                                        //     setPropertyFor(e.target.value);
                                        // }}
                                        onChange={(e) => handleFilterChange('PropertyFor', e.target.value)}

                                    >
                                        <option value="">Select</option>
                                        <option value="1">Buy</option>
                                        <option value="2">Rent</option>
                                        <option value="3">Sell</option>
                                    </select>
                                </div>

                                <div style={isMobile ? { width: "340px" } : { width: "190px" }}>
                                    <label className="d-block" style={{ color: "#ffffff" }}>Building Type</label>
                                    <select
                                        className="form-control"
                                        value={selectBuildingType}
                                        // onChange={(e) => {
                                        //     setQueryParams('PropertyType', e.target.value);
                                        //     setSelectedBuildingType(e.target.value);
                                        // }}
                                        onChange={(e) => handleFilterChange('PropertyType', e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {Buildingdata?.map((item) => (
                                            <option key={item.id} value={item.name}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Construction Type */}
                                <div style={isMobile ? { width: "340px" } : { width: "190px" }}>
                                    <label className="d-block" style={{ color: "#ffffff" }}>Construction Type</label>
                                    <select
                                        className="form-control"
                                        value={selectedConstructionType}
                                        onChange={(e) => handleFilterChange('ConstructionType', e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        <option value="ready">Ready To Move</option>
                                        <option value="offplan">Off-Plan</option>
                                    </select>
                                </div>

                                {/* BHK Type */}
                                <div style={isMobile ? { width: "340px" } : { width: "190px" }}>
                                    <label className="d-block" style={{ color: "#ffffff" }}>Bedrooms Type</label>
                                    <select
                                        className="form-control"
                                        value={selectBHK}
                                        // onChange={(e) => {
                                        //     setQueryParams('BHKType', e.target.value);
                                        //     setSelectedBHK(e.target.value);
                                        // }}
                                        onChange={(e) => handleFilterChange('BedroomsType', e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        <option value="1bedrooms">1Bedroom</option>
                                        <option value="2bedrooms">2Bedrooms</option>
                                        <option value="3bedrooms">3Bedrooms</option>
                                        <option value="4bedrooms">4Bedrooms</option>
                                    </select>
                                </div>

                                {/* Reset */}
                                <div className="text-center">
                                    <button onClick={handleResetFilter} className="btn btn-yellow mt-4">
                                        <span className="left"><i className="fa fa-search" /></span> Reset Filter
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>

    );
};

export default SearchGridNeww;